export default function Header({ article }) {
  return (
    <div className='pb-6 mt-3 flex'>
      <div className='text-[1.7rem] '>{ article.title }</div>
    </div>
  )
}
